<template>
    <common-layout>
        <div class="login-container">
            <a-row>
                <a-col :span="14">
                    <div class="login-left"></div>
                </a-col>
                <a-col :span="10">
                    <div class="login-right">
                        <div class="login-form-content">
                            <div class="login-warp">
                                <div class="login-form-title">
                                    <div><img src="@/assets/svg/school-logo.png" height="60" /></div>
                                    <div class="title">
                                        <strong>{{ systemName }}</strong>
                                    </div> 
                                </div>
                                <div class="login-form">
                                    <a-form-model
                                        ref="loginForm"
                                        :model="formObject"
                                        :rules="rules"
                                    >
                                        <a-form-model-item prop="mobile">
                                            <a-input v-emoji
                                                :size="size"
                                                v-model="formObject.mobile"
                                                allow-clear
                                                autocomplete="off"
                                                placeholder="手机号"
                                                @pressEnter="onSubmit"
                                            >
                                                <a-icon
                                                    slot="prefix"
                                                    type="user"
                                                    style="color: rgba(0, 0, 0, 0.25)"
                                                />
                                            </a-input>
                                        </a-form-model-item>
                                        <a-form-model-item prop="password">
                                            <a-input-password
                                                :size="size"
                                                v-model="formObject.password"
                                                type="password"
                                                autocomplete="off"
                                                placeholder="密码"
                                                @pressEnter="onSubmit"
                                            >
                                                <a-icon
                                                    slot="prefix"
                                                    type="lock"
                                                    style="color: rgba(0, 0, 0, 0.25)"
                                                />
                                            </a-input-password>
                                        </a-form-model-item>
                                        <a-form-model-item>
                                            <a-checkbox
                                                @change="onRemember"
                                                :checked="checked"
                                            >
                                                记住账号
                                            </a-checkbox>
                                            
                                            <a-popover title="提示" placement="right">
                                                <template #content>
                                                    <p>如忘记手机号、登录密码，</p>
                                                    <p>请联系管理员</p>
                                                </template>
                                                
                                                <a class="login-form-forgot">忘记密码？</a>
                                            </a-popover>
                                            
                                        </a-form-model-item>
                                        <a-form-model-item>
                                            <a-button
                                                :size="size"
                                                type="primary"
                                                :loading="logging"
                                                @click="onSubmit"
                                                block
                                            >
                                                登录
                                            </a-button>
                                        </a-form-model-item>
                                    </a-form-model>
                                </div>
                                <div class="footer">
                                    <page-footer :link-list="footerLinks" :copyright="copyright"></page-footer>
                                </div>
                            </div>
                        </div>
                        
                    </div>
                </a-col>
            </a-row>
        </div>
    </common-layout>
</template>

<script>
import CommonLayout from '@/layouts/CommonLayout';
import PageFooter from '@/layouts/footer/PageFooter'
import // login,
// getRoutesConfig
'@/services/user';
import { setAuthorization } from '@/utils/request';
import { loadRoutes } from '@/utils/routerUtil';
import { mapMutations, mapState } from 'vuex';
import { login, getRouter } from '@/services/login';
import CryptoJS from 'crypto-js';
import config from '@/pathConfig';
export default {
    name: 'Login',
    components: {
        CommonLayout,
        PageFooter
    },
    data() {
        return {
            logging: false,
            error: '',
            
            size: 'large',
            formObject: {
                mobile: '',
                password: '',
            },
            rules: {
                mobile: [
                    { required: true, message: '请输入手机号', trigger: 'change' }
                ],
                password: [
                    { required: true, message: '请输入密码', trigger: 'change' }
                ]
            },
            key: 'login-mobile',
            checked: false
        };
    },
    computed: {
        ...mapState('setting', ['footerLinks', 'copyright']),
        systemName() {
            return this.$store.state.setting.systemName;
        }
    },
    created() {
        const { $storage, key } = this
        
        const mobile = $storage.get(key);
        if (mobile) {
            this.checked = true
            this.formObject.mobile = mobile;
        }
    },
    methods: {
        ...mapMutations('account', ['setUser', 'setPermissions', 'setRoles']),
        encryption(pas) {
            var key = CryptoJS.enc.Utf8.parse('MYYC-Hyd20220601'); //秘钥
            var srcs = CryptoJS.enc.Utf8.parse(pas);
            var encrypted = CryptoJS.AES.encrypt(srcs, key, {
                mode: CryptoJS.mode.ECB,
                padding: CryptoJS.pad.Pkcs7
            });
            return encrypted.toString();
        },
        onSubmit() {
            const { $refs, formObject, encryption, afterLogin, checked } = this;
            let that = this;
            
            $refs.loginForm.validate(valid => {
                if (valid) {
                    this.logging = true;
                    login(formObject.mobile, that.encryption(formObject.password)).then(res => {
                        // 如果记住账号为选中，则进行记录
                        if(checked) {
                            this.remember(checked)
                        }
                        afterLogin(res)
                    });
                }
            })
        },
        afterLogin(res) {
            this.logging = false;
            var completeRouter = ''
            const loginRes = res.data;
            if (loginRes.code == 200) {
                console.log(loginRes);
                let token = loginRes.token;
                let userinfo = loginRes.data;
                // 登录成功缓存用户信息
                this.$hdk.userInfo.set(userinfo);
                sessionStorage.setItem('login_name',userinfo.userName);
                sessionStorage.setItem('token', token);

                userinfo.avatar =  userinfo.avatarUrl;
                this.setUser(userinfo);
                this.setRoles(userinfo.userRole);
                setAuthorization(token);
                getRouter(userinfo.userId).then(res => {
                    if (res.data.code == 200) {
                        const routesConfig = res.data.data;
                        console.log(routesConfig);
                        
                        loadRoutes(routesConfig);
                        if(routesConfig[0].children && routesConfig[0].children.length != 0){
                                //走表单页面
                            if(routesConfig[0].children[0].router == 'formReview' && routesConfig[0].children[0].children && routesConfig[0].children[0].children.length != 0){
                                completeRouter = routesConfig[0].children[0].router + '/' + routesConfig[0].children[0].children[0].router +'/' + routesConfig[0].children[0].children[0].children[0].router
                            } else {
                                //走正常页面
                                completeRouter = routesConfig[0].children[0].router + '/' + routesConfig[0].children[0].children[0].router
                            }
                        } else {
                            this.$message.error('暂未分配权限，请联系管理员', 3);
                            return
                        }
                        console.log(completeRouter);
                        this.$router.push(completeRouter);
                        this.$message.success(loginRes.message, 3);
                        this.$bus.$emit('loginSuccess');
                    }
                });
            } else {
                this.error = loginRes.message;
            }
        },
        onRemember(e) {
            this.checked = e.target.checked;
            this.remember(e.target.checked)
        },
        remember(val) {
            const { $storage, key, formObject } = this
            const mobile = formObject.mobile;
            val ? $storage.set(key, mobile) : $storage.remove(key)
        }
    }
};
</script>

<style lang="less" scoped>
.common-layout {
    .login-container {
        background-image: url('../../assets/svg/login-bg.jpg');
        height: 100vh;
        overflow: auto;
        background-repeat: no-repeat;
        background-position-x: center;
        background-size: cover;
        
        .login-left {
            width: 100%;
            height: calc(100vh);
            // background-image: url('../../assets/svg/login-bg.jpg');
        }
        .login-right { 
            height: calc(100vh);
            // background-color: white;
            position: relative;
            .login-form-content {
                max-width: 33rem;
                margin: auto;
                font-size: 0.3rem;
                padding-top: calc(22vh);
                .login-warp {
                    -webkit-box-shadow: 4px 2px 8px #333;
                    box-shadow: 4px 2px 8px #333;
                    padding: 15px;
                    -webkit-backdrop-filter: blur(8px);
                    backdrop-filter: blur(8px);
                    background-color: rgba(255,255,255,0.85);
                    border-radius: 5px;
                        
                    // box-shadow: 4px 2px 8px #333;
                    // padding: 15px;
                    // background-color:rgba(255,255,255,0.85);
                    // border-radius: 5px;
                    // backdrop-filter: blur(8px);
                }
                .login-form-title {
                    margin-top: 15px;
                    text-align: center;
                    .title {
                        font-size: 24px; 
                        margin: 30px 10px 40px;
                    }
                }
                .login-form-forgot {
                    float: right;
                }
            }
            .footer {
                // position: absolute;
                // left: 0;
                // right: 0;
                // bottom: 0;
                // text-align: center;
                /deep/.footer {
                    padding: 0!important;
                }
            }
        }
    }
}
</style>
